import { useEffect, useRef, useState } from 'react';

import Button from 'components/partials/button/button';
import { TextArea } from 'ui/text-area';

import Icons from 'assets/icons';

interface NotePanelProps {
  initialText?: string;
  mode?: 'add' | 'edit';
  onSave: (text: string) => void;
  onCancel: () => void;
  onDelete?: () => void;
}

const NotePanel = ({
  initialText = '',
  mode = 'add',
  onSave,
  onCancel,
  onDelete,
}: NotePanelProps) => {
  const [text, setText] = useState(initialText);
  const textareaRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    textareaRef.current?.focus();
  }, []);

  return (
    <div
      className="bg-white p-6 rounded-md w-[450px] z-[2]"
      style={{ boxShadow: '0 4px 10px -2px rgba(0, 45, 93, 0.20)' }}
    >
      <p className="text-gray-700 font-semibold mb-2">Insights</p>
      <div ref={textareaRef}>
        <TextArea
          aria-label="Note"
          placeholder="Use this area to leave a note..."
          maxLength={1000}
          value={text}
          onChange={(val) => setText(val)}
        />
      </div>
      <div className="mt-5 text-right flex items-center justify-between">
        <div>
          {onDelete && (
            <Button
              variant="critical-text"
              size="sm"
              onClick={onDelete}
              iconBefore={<Icons.Delete />}
            >
              Delete
            </Button>
          )}
        </div>
        <div className="flex items-center gap-3">
          <Button
            variant="reserve-outlined"
            size="sm"
            onClick={onCancel}
            data-testid="cancel-note-button"
          >
            Cancel
          </Button>
          <Button
            variant="brand-filled"
            size="sm"
            onClick={() => onSave(text)}
            disabled={!text?.trim()}
            data-testid="save-note-button"
          >
            {mode === 'add' ? 'Add note' : 'Save'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotePanel;
